export default fn => Object.assign({}, { click: fn })
